import * as types from "./mutations-type";
export default{
   
    [types.SET_TRABALHADORES](state,payload){
        state.trabalhador = payload
    },
    
}